import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\GetItemsFromAutomationController::__invoke
* @see app/Http/Controllers/Invoice/GetItemsFromAutomationController.php
* @route '/api/invoicing/{invoice}/automations-items'
*/
const GetItemsFromAutomationController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemsFromAutomationController.url(args, options),
    method: 'get',
})

GetItemsFromAutomationController.definition = {
    methods: ["get","head"],
    url: '/api/invoicing/{invoice}/automations-items',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Invoice\GetItemsFromAutomationController::__invoke
* @see app/Http/Controllers/Invoice/GetItemsFromAutomationController.php
* @route '/api/invoicing/{invoice}/automations-items'
*/
GetItemsFromAutomationController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return GetItemsFromAutomationController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\GetItemsFromAutomationController::__invoke
* @see app/Http/Controllers/Invoice/GetItemsFromAutomationController.php
* @route '/api/invoicing/{invoice}/automations-items'
*/
GetItemsFromAutomationController.get = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemsFromAutomationController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Invoice\GetItemsFromAutomationController::__invoke
* @see app/Http/Controllers/Invoice/GetItemsFromAutomationController.php
* @route '/api/invoicing/{invoice}/automations-items'
*/
GetItemsFromAutomationController.head = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemsFromAutomationController.url(args, options),
    method: 'head',
})

export default GetItemsFromAutomationController